import React from 'react';
import PropTypes from 'prop-types';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from './IconButton';
import StyledInputClearIcon from './InputClearIcon.styled';
function InputClearIcon(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(StyledInputClearIcon, null, /*#__PURE__*/React.createElement(IconButton, {
    onClick: onClick,
    size: "small",
    color: "inherit"
  }, /*#__PURE__*/React.createElement(CancelIcon, null)));
}
InputClearIcon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Function to handle click event
   */
  onClick: PropTypes.func.isRequired
} : {};
export default InputClearIcon;